function dynamicEnding(array, ending = "s") {
  if (array.length > 1) return ending;
}

export { dynamicEnding };
